/**
 * Runtime environment config (WRDS-430).
 *
 * Endpoint values come from /env.js (window.__WILREJI_ENV__), a plain file
 * written next to the bundle — overwrite it in the frontend bucket and
 * invalidate /env.js to repoint the app with NO rebuild. The bundle itself is
 * environment-agnostic.
 *
 * Build-time CRA values are the fallback so local dev (`npm start` +
 * environments/*.env) keeps working unchanged, and so the app still boots if
 * env.js is ever missing.
 *
 * NOTE: CRA only inlines LITERAL `process.env.REACT_APP_X` expressions —
 * dynamic `process.env[key]` access does not exist in the browser. Keep the
 * fallback table literal.
 */
const buildEnv = {
  REACT_APP_SERVER_BASE_URL: process.env.REACT_APP_SERVER_BASE_URL,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  REACT_APP_WEB_BASE_URL: process.env.REACT_APP_WEB_BASE_URL,
  REACT_APP_PRODUCTION: process.env.REACT_APP_PRODUCTION,
  REACT_APP_WAITER_ORIGIN: process.env.REACT_APP_WAITER_ORIGIN,
};

const runtimeEnv =
  (typeof window !== "undefined" && window.__WILREJI_ENV__) || {};

const LOCALHOST_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);
const URL_ENV_KEYS = new Set([
  "REACT_APP_SERVER_BASE_URL",
  "REACT_APP_API_URL",
  "REACT_APP_SOCKET_URL",
  "REACT_APP_WEB_BASE_URL",
  "REACT_APP_WAITER_ORIGIN",
]);

const getWindowLocation = () =>
  (typeof window !== "undefined" ? window.location : undefined);

export const normalizeLocalNetworkUrl = (key, value, location = getWindowLocation()) => {
  if (!URL_ENV_KEYS.has(key) || !value || !location?.hostname) {
    return value;
  }

  if (LOCALHOST_HOSTS.has(location.hostname)) {
    return value;
  }

  try {
    const parsedUrl = new URL(value);
    if (!LOCALHOST_HOSTS.has(parsedUrl.hostname)) {
      return value;
    }

    parsedUrl.hostname = location.hostname;

    if (!value.endsWith("/") && parsedUrl.pathname === "/" && !parsedUrl.search && !parsedUrl.hash) {
      return parsedUrl.toString().replace(/\/$/, "");
    }

    return parsedUrl.toString();
  } catch {
    return value;
  }
};

export const resolveRuntimeEnvValue = (key, runtimeValue, buildValue, location = getWindowLocation()) => {
  const value = runtimeValue !== undefined ? runtimeValue : buildValue;
  return normalizeLocalNetworkUrl(key, value, location);
};

const env = (key) =>
  resolveRuntimeEnvValue(key, runtimeEnv[key], buildEnv[key]);

export const SERVER_BASE_URL = env("REACT_APP_SERVER_BASE_URL");
export const API_URL = env("REACT_APP_API_URL");
export const SOCKET_URL = env("REACT_APP_SOCKET_URL");
export const WEB_BASE_URL = env("REACT_APP_WEB_BASE_URL");
export const PRODUCTION = env("REACT_APP_PRODUCTION");
export const WAITER_ORIGIN = env("REACT_APP_WAITER_ORIGIN");
